// extracted by mini-css-extract-plugin
export default {"container":"record__container___zWPuS","newRecordCreated":"record__newRecordCreated___WkT__"};